import './Notifications.css';

export const ModalSize = Object.freeze({
    SUPERSMALL: "supersmall",
    SMALL:   "small",
    MEDIUM:  "medium",
    LARGE:  "large",
    SUPERWIDE: "superwide"
  });